import type { Recording } from "@sunrise/backend-types";
import { Nullable } from "@sunrise/utils";

export const isFullyRecorded = (recording: Nullable<Recording>): boolean => {
  if (!recording) {
    return false;
  }
  return recording.status === "recorded";
};
